import React from "react";
import { Link } from "react-router-dom";
import { MarketingLayout } from "../../components/marketing/MarketingLayout";
import { MarketingCTA } from "../../components/marketing/MarketingCTA";
import { SEO } from "../../components/seo/SEO";
import { breadcrumbSchema } from "../../components/seo/schema";
import { getMarketingIcon } from "../../data/marketingIcons";
import { SOLUTIONS } from "../../data/solutionsData";

export default function SolutionsIndex() {
  const breadcrumb = [{ name: "Home", path: "/" }, { name: "Solutions", path: "/solutions" }];
  return (
    <MarketingLayout breadcrumb={breadcrumb}>
      <SEO
        title="Solutions for Home Service Businesses | ServiceGuru Pro"
        description="Explore ServiceGuru Pro solutions for dispatching, field service management, contractor CRM, AI for contractors, marketing automation, and technician management."
        path="/solutions"
        jsonLd={[breadcrumbSchema(breadcrumb)]}
      />
      <section className="max-w-4xl mx-auto px-5 lg:px-8 pt-12 pb-14 text-center">
        <h1 className="text-4xl sm:text-5xl font-black tracking-tight leading-[1.05] mb-5" data-testid="solutions-index-h1">
          Solutions for Real Business Problems
        </h1>
        <p className="text-[15.5px] text-slate-400 leading-relaxed max-w-2xl mx-auto">
          Not just features — real solutions to the problems that slow down home service businesses every day.
        </p>
      </section>

      <section className="max-w-6xl mx-auto px-5 lg:px-8 pb-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {SOLUTIONS.map((s) => {
            const Icon = getMarketingIcon(s.icon);
            return (
              <Link
                key={s.slug}
                to={`/solutions/${s.slug}`}
                data-testid={`solutions-index-card-${s.slug}`}
                className="rounded-2xl border border-white/10 bg-white/[0.02] p-5 hover:border-emerald-400/50 hover:bg-white/[0.04] transition-colors group"
              >
                <div className="h-10 w-10 rounded-xl bg-emerald-500/15 border border-emerald-500/20 flex items-center justify-center mb-3">
                  <Icon className="h-5 w-5 text-emerald-400" />
                </div>
                <p className="text-emerald-400 text-[11px] font-bold uppercase tracking-wide mb-1">{s.painPoint}</p>
                <h3 className="text-white font-semibold text-[14.5px] group-hover:text-emerald-400 transition-colors">{s.title}</h3>
              </Link>
            );
          })}
        </div>
      </section>

      <MarketingCTA heading="Ready to solve it for good?" sub="Start your 14-day free trial — no credit card required." />
    </MarketingLayout>
  );
}
